import { useEffect, useRef, useState } from 'react';
import { actionsType } from 'config/constants';
import PubSub from 'services/PubSub/';
import LoginService from 'services/Login';

const useIsMounted = () => {
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => isMounted.current = false;
    }, []);
    return isMounted;
};

const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const useViewportMediaQuery = (size = '1024') => {
    if(typeof window === 'undefined') return null

    const [isMobile, setIsMobile] = useState(null)
    const mediaQueryList = window.matchMedia(`(min-width: ${size}px)`)

    const setter = () => {
        setIsMobile(!mediaQueryList.matches)
    }

    useEffect(() => {
        setter()
        mediaQueryList.addListener(setter)
        
        return function cleanup() {
            mediaQueryList.removeListener(setter)
        }

    },[])

    return isMobile
}

let actions = [];

const useLogged = () => {
    const [isLogged, setIsLogged] = useState(false)

    useEffect(() => {
        validateSession();
        actions.push(PubSub.register(actionsType.LOGGED_IN, validateSession));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, [])

    const validateSession = () => {
        setIsLogged(LoginService.isLogged());
    }

    return isLogged
}

export  {
    useIsMounted,
    usePrevious,
    useViewportMediaQuery,
    useLogged
};
